/**
 * @desc 财务画像-财务舞弊-应收款项账龄
*/
import style from './echartsHeight.scss';
import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';
import React from 'react';
import BBDPie from '../../../../common/echarts/BBDPie';
import { Table, Row, Col, Spin } from 'antd';

export default class CollectNum extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            option: {},
            data: []
        };
    }

    formatResponse = (data) => {
        let pieData = [];
        data.forEach(item => {
            pieData.push({ name: item.name, value: item.balance });
        });
        return {
            option: {
                legend: {
                    x: 'center',
                    y: 'bottom'
                },
                data: pieData
            },
            data: data
        };
    };

    columnsData = () => {
        return [
            {
                title: '账龄',
                dataIndex: 'name'
            },
            {
                title: '期末余额',
                dataIndex: 'balance'
            },
            {
                title: '占应收账款比例',
                dataIndex: 'percent'
            }
        ];
    };

    render() {
        const { loading, option, data } = this.state;
        return (
            <div className={style.netProfitBar}>
                <div className="sub-title">应收款项账龄</div>
                <Row>
                    <Col span={12}>
                        <Table
                            bordered
                            rowKey="order"
                            dataSource={data}
                            columns={this.columnsData()}
                            pagination={false}
                        />
                    </Col>
                    <Col span={12}>
                        <div className={style.reduceShareholder}>
                            {
                                loading ?
                                    <Spin /> :
                                    <BBDPie option={option} />
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/CollectNum.jsx